<template>
  <div class="icon-group">
    <p class="line-top" v-if="lineTop">{{ lineTop.toLowerCase() }}</p>
    <p class="line-bottom" v-if="lineBottom">{{ lineBottom }}</p>
    <div class="icons">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'IconGroup',

  provide () {
    return {
      group: this
    }
  },

  props: {
    lineTop: {
      type: [ String, undefined ],
      default: undefined
    },

    lineBottom: {
      type: [ String, undefined ],
      default: undefined
    }
  },

  data () {
    return {
      selected: undefined
    }
  },

  methods: {
    select (index) {
      this.selected = index
      this.$emit('select', index)
    }
  }
}
</script>

<style lang="sass">
.icon-group
  p
    &.line-top
      margin-bottom: 2px
    &.line-bottom
      margin-bottom: 4px

.icons
  display: flex
  .icon
    margin-right: 4px
</style>
